import { render, staticRenderFns } from "./HouseRequest.vue?vue&type=template&id=fdfc2356"
import script from "./HouseRequest.vue?vue&type=script&lang=js"
export * from "./HouseRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports